import { render } from "./ScrollParallax.vue?vue&type=template&id=464a7a85"
import script from "./ScrollParallax.vue?vue&type=script&lang=js"
export * from "./ScrollParallax.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__